import { useNavigate } from 'react-router';
import { RouteStates, RouteState } from 'Router/types';

export function useTypedNavigate() {
  const navigate = useNavigate();

  return {
    // Type-safe navigation with state
    navigateWithState: <T extends keyof RouteStates>(
      to: string,
      state: RouteState<T>,
    ) => {
      navigate(to, { state });
    },

    // Regular navigate for backward compatibility
    navigate,
  };
}
